import { createProxy, createProxyBase } from "./proxy";

const uri = {   
    authorizations : createProxyBase('authorizations'),  
    areas : createProxyBase('areas'),  
    bills : createProxyBase('bills'),   
    prebills : createProxyBase('prebills'),   
    clients : createProxyBase('clients'),   
    goals : createProxyBase('goals'),   
    goalUsers : createProxyBase('goalUsers'),   
    expenses : createProxyBase('expenses'),   
    productConvertions : createProxyBase('productConvertions'),   
    cuts : createProxyBase('cuts'),   
    compras: createProxyBase('purchases'),   
    purchaseReceipts: createProxyBase('purchaseReceipts'),   
    movements: createProxyBase('movements'),      
    providers : createProxyBase('providers'),  
    estados: createProxyBase('estados'),
    file: createProxy('', 'percapitas/post/file'),
    fileRates: createProxy('', 'rates/post/file'),
    inPutProducts: createProxyBase('inPutProducts'),  
    outPutProducts: createProxyBase('outPutProducts'),  
    traslates: createProxyBase('traslates'),    
    products: createProxyBase('products'),
    roles:createProxyBase('roles'),
    users:createProxyBase('users'),
    rates:createProxyBase('rates'),
    receivables: createProxyBase('receivables'),
    vendors: createProxyBase('vendors'),
    comissions: createProxyBase('Comissions'),
    areaProducts : areaId => createProxyBase(`area/${areaId}/products`) ,
    areaProductConvert : areaId => createProxyBase(`area/${areaId}/products/convert`),
    dashboard: createProxyBase('dashboard'),
};

uri.resources= roleId => `roles/${roleId}/resources`;
uri.products.getByArea = areaId => `products/getbyarea/${areaId}`;
uri.products.getByAreaGrid = areaId => `products/getbyarea/${areaId}/grid`;
uri.clients.asCatalog = 'clients/asCatalog';

uri.receivables.byBill = billId =>`receivables/bill/get/${billId}`;
uri.new_catalog = `catalogos/new-catalog`;

uri.account = 'account/auth';
uri.changepassword = 'account/changepassword';
uri.resetPassword = 'account/resetpassword';


export const routeReset = props => props.history.push({ pathname : '/app/navig' }, { returnUrl: props.location.pathname }); 


export default uri;